import { loaderStoreType } from "./type";

export const initialState: loaderStoreType = {
    value: false,
};
